import cn from 'classnames';

/**
 * I don't know that this will work but I want to try it.
 */
export const fieldSetClassNames = cn('relative w-full');

// Not used by the Select component.
export const inputClassNames = cn(
	'peer min-h-14 w-full rounded-xl border border-slate-300 px-3 pb-2 pt-6 text-base font-normal text-slate-500 outline-none focus:border-sky-600 focus:text-black disabled:bg-slate-100 disabled:text-slate-400 [&:not(:focus):not(:placeholder-shown)]:invalid:border-pink-600',
);

// Not used by the Select component
export const labelClassNames = cn(
	'absolute left-3 top-0 block origin-top-left translate-y-2 scale-75 transform text-base font-normal text-slate-500 transition-transform duration-200 peer-placeholder-shown:translate-x-0 peer-placeholder-shown:translate-y-4 peer-placeholder-shown:scale-100 peer-focus:translate-y-2 peer-focus:scale-75 peer-disabled:text-slate-400',
);

export const contextRowClassNames = cn('mt-2 flex justify-between px-3');

export const helperTextClassNames = cn('text-xs font-normal text-slate-500');

export const characterCountLimitClassNames = cn(
	'shrink-0 text-xs font-normal text-slate-500',
);
